// extracted by mini-css-extract-plugin
export default {"typography":"MGTypography_typography__n2FrI"};